import axios from '../../../lib/axios';
import React, { createRef, useEffect, useState } from 'react';
import { SuppliesMainGroupName } from '../../../models/suppliesMain';
import {
  MASTER_MAIN_GROUP_FIND_MANY,
  MASTER_MAIN_GROUP_DELETE,
  MASTER_DIVISION_FIND_MANY,
  MASTER_CATEGORIES_FIND_MANY,
  MASTER_SUB_CATEGORIES_FIND_MANY,
  IMPORT_MASTER_MAIN_GROUP_CSV,
  IMPORT_MASTER_DIVISION_CSV,
  IMPORT_MASTER_CATEGORIES_CSV,
  IMPORT_MASTER_SUB_CATEGORIES_CSV,
} from '../../../lib/endpoints/category';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../models/suppliesSubCategory';
import {
  MainGroupCsvHeader,
  MasterCategoriesCsvHeader,
  MasterDivisionCsvHeader,
  MasterSubCategoriesCsvHeader,
} from './model/csv';
import { getAllMasterMainGroup } from '../../../services/masterMainGroup';

const useCategoryController = () => {
  const [data, setData] = useState<SuppliesMainGroupName[]>([]);
  const [dataMasterDivision, setDataMasterDivision] = useState<SuppliesDivisionModel[]>([]);
  const [dataMasterCategories, setDataMasterCategories] = useState<SuppliesCategoryProduct[]>([]);
  const [dataMasterSubCategories, setDataMasterSubCategories] = useState<
    SuppliesProductSubCategory[]
  >([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState<SuppliesMainGroupName[]>([]);
  const [selectedDeleteId, setSelectedDeleteId] = useState<string>('');
  const [selectedMainCategoryId, setSelectedMainCategoryId] = useState<SuppliesMainGroupName>(
    null!
  );
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openMainCategory, setOpenMainCategory] = useState<boolean>(false);
  const [loadingUpdateAllCategories, setLoadingUpdateAllCategories] = useState<boolean>(false);
  const [loadingUpdateData, setLoadingUpdateData] = useState<boolean>(false);

  const [loadingImportMasterMain, setLoadingImportMasterMain] = useState<boolean>(false);
  const [loadingImportMasterDivision, setLoadingImportMasterDivision] = useState<boolean>(false);
  const [loadingImportMasterCategories, setLoadingImportMasterCategories] =
    useState<boolean>(false);
  const [loadingImportMasterSubCategories, setLoadingImportMasterSubCategories] =
    useState<boolean>(false);

  const [loadingButtonDelete, setLoadingButtonDelete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');

  const [dataExportMainGroupCsv, setDataExportMainGroupCsv] = useState<MainGroupCsvHeader[]>([]);
  const [dataExportDivisionCsv, setDataExportDivisionCsv] = useState<MasterDivisionCsvHeader[]>([]);
  const [dataExportCategoriesCsv, setDataExportCategoriesCsv] = useState<
    MasterCategoriesCsvHeader[]
  >([]);
  const [dataExportSubCategories, setDataExportSubCategories] = useState<
    MasterSubCategoriesCsvHeader[]
  >([]);

  const [isInit, setIsInit] = useState<boolean>(false);

  const buttonExportMainRef = createRef<any>();
  const buttonExportDivisionRef = createRef<any>();
  const buttonExportCategoriesRef = createRef<any>();
  const buttonExportSubCategoriesRef = createRef<any>();

  // ------------- Export Csv function ---------------//
  const handleExportMasterMainCsv = async () => {
    try {
      setLoadingUpdateData(true);
      const getDataMasterMainCategories: SuppliesMainGroupName[] = filterData;

      if (getDataMasterMainCategories?.length > 0) {
        const getDataCsv = getDataMasterMainCategories?.map((item: SuppliesMainGroupName) => {
          return {
            no_main: item?.id,
            code: item?.code,
            description: '',
            main_group_name_en: item?.main_group_name_en,
            main_group_name_la: item?.main_group_name_la,
          };
        });
        setDataExportMainGroupCsv(getDataCsv);
      } else {
        window.alert('Not found master main group');
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingUpdateData(false);
    }
  };

  const handleExportMasterDivisionCsv = async () => {
    try {
      setLoadingUpdateData(true);
      const getDataMasterDivision: SuppliesDivisionModel[] = dataMasterDivision;
      if (getDataMasterDivision?.length > 0) {
        const getDataCsv = getDataMasterDivision?.map((item: SuppliesDivisionModel) => {
          return {
            no_div: item?.id,
            division_name_en: item?.division_name_en,
            division_name_la: item?.division_name_la,
            master_main_group_name: data.filter(
              (subItem) => subItem?.id === item?.supplies_main_group_name_id
            )[0]?.main_group_name_en,
            description: '',
            code: item?.code,
          };
        });
        setDataExportDivisionCsv(getDataCsv);
      } else {
        window.alert('Not found master division');
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingUpdateData(false);
    }
  };

  const handleExportMasterCategoriesCsv = async () => {
    try {
      setLoadingUpdateData(true);
      const getDataMasterCategories: SuppliesCategoryProduct[] = dataMasterCategories;
      if (getDataMasterCategories?.length > 0) {
        const getDataCsv = getDataMasterCategories?.map((item: SuppliesCategoryProduct) => {
          return {
            no_cat: item?.id,
            category_name_en: item?.category_name_en,
            category_name_la: item?.category_name_la,
            masterDivisionName: dataMasterDivision.filter(
              (subItem) => subItem?.id === item?.supplies_division_name_id
            )[0]?.division_name_en,
            description: '',
            code: item?.code,
          };
        });
        setDataExportCategoriesCsv(getDataCsv);
      } else {
        window.alert('Not found master categories');
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingUpdateData(false);
    }
  };

  const handleExportMasterSubCategoriesCsv = async () => {
    try {
      setLoadingUpdateData(true);
      const getDataMasterSubCategories: SuppliesProductSubCategory[] = dataMasterSubCategories;
      if (getDataMasterSubCategories?.length > 0) {
        const getDataCsv = getDataMasterSubCategories?.map((item: SuppliesProductSubCategory) => {
          return {
            no_sub: item?.id,
            sub_category_name_en: item?.sub_category_name_en,
            sub_category_name_la: item?.sub_category_name_la,
            masterCategoryName: dataMasterCategories.filter(
              (subItem) => subItem?.id === item?.supplies_product_category_id
            )[0]?.category_name_en,
            description: '',
            code: item?.code,
          };
        });
        setDataExportSubCategories(getDataCsv);
      } else {
        window.alert('Not found master sub categories');
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingUpdateData(false);
    }
  };

  // ------------- End ---------------//

  // ------------- Import Csv file -------------------//

  const handleUploadMainGroup = async (file: File) => {
    try {
      if (file) {
        setLoadingImportMasterMain(true);
        const formData: any = new FormData();
        formData.append('file', file);
        const res = await axios.post(IMPORT_MASTER_MAIN_GROUP_CSV, formData);
        await handleFetchDataMainCategory();
        window.alert(res?.data?.message);
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingImportMasterMain(false);
    }
  };

  const handleUploadDivision = async (file: File) => {
    try {
      if (file) {
        setLoadingImportMasterDivision(true);
        const formData: any = new FormData();
        formData.append('file', file);
        const res = await axios.post(IMPORT_MASTER_DIVISION_CSV, formData);
        window.alert(res?.data?.message);
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingImportMasterDivision(false);
    }
  };

  const handleUploadCategories = async (file: File) => {
    try {
      if (file) {
        setLoadingImportMasterCategories(true);
        const formData: any = new FormData();
        formData.append('file', file);
        const res = await axios.post(IMPORT_MASTER_CATEGORIES_CSV, formData);
        window.alert(res?.data?.message);
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingImportMasterCategories(false);
    }
  };

  const handleUploadSubCategories = async (file: File) => {
    try {
      if (file) {
        setLoadingImportMasterSubCategories(true);
        const formData: any = new FormData();
        formData.append('file', file);
        const res = await axios.post(IMPORT_MASTER_SUB_CATEGORIES_CSV, formData);
        window.alert(res?.data?.message);
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingImportMasterSubCategories(false);
    }
  };

  // ------------- End ---------------//

  const handleFetchDataMainCategory = async () => {
    try {
      setLoading(true);
      const resData = await getAllMasterMainGroup();
      setData(resData);
    } catch (err) {
      // console.log('error', err);
    }
  };

  const handleFetchAllMasterCategories = async () => {
    try {
      setLoadingUpdateAllCategories(true);
      const { data: allMasterMainGroup }: { data: SuppliesMainGroupName[] } = await axios.post(
        MASTER_MAIN_GROUP_FIND_MANY
      );
      // console.log('Main ==', allMasterMainGroup);

      const { data: allDivision }: { data: SuppliesDivisionModel[] } = await axios.post(
        MASTER_DIVISION_FIND_MANY
      );
      setDataMasterDivision(allDivision);

      const { data: allCategory }: { data: SuppliesCategoryProduct[] } = await axios.post(
        MASTER_CATEGORIES_FIND_MANY
      );
      setDataMasterCategories(allCategory);

      const { data: allSubCategory }: { data: SuppliesProductSubCategory[] } = await axios.post(
        MASTER_SUB_CATEGORIES_FIND_MANY
      );
      setDataMasterSubCategories(allSubCategory);
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingUpdateAllCategories(false);
    }
  };

  const handleDelete = async () => {
    setLoadingButtonDelete(true);
    try {
      await axios.delete(`${MASTER_MAIN_GROUP_DELETE + selectedDeleteId}`);
      await handleFetchDataMainCategory();
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingButtonDelete(false);
      handleCloseDeleteForm();
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleOpenEdit = (id: string) => {
    setOpenMainCategory(true);
    const getEditData: SuppliesMainGroupName = data.filter((item) => item.id === id)[0];
    setSelectedMainCategoryId(getEditData);
  };

  const handleOpenDelete = (id: string) => {
    setOpenDeleteForm(true);
    setSelectedDeleteId(id);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleOpenAddCategory = () => {
    setOpenMainCategory(!openMainCategory);
  };
  const handleCloseAddCategory = () => {
    setOpenMainCategory(false);
  };

  const handleOpenForm = (id: string) => {
    setOpenForm(!openForm);
    const selectedData = data.filter((item) => item.id === id);
    setSelectedMainCategory(selectedData);
  };
  const handleCloseForm = () => {
    setOpenForm(false);
  };

  //filter Data
  const filterData: SuppliesMainGroupName[] = data.filter(
    (main: SuppliesMainGroupName) =>
      main?.code?.toLowerCase()?.includes(searchValue.toLowerCase()) ||
      main?.main_group_name_la?.toLocaleLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
      main?.main_group_name_en?.toLocaleLowerCase()?.includes(searchValue.toLocaleLowerCase())
  );

  const isSearchNotFound: boolean = !filterData.length && !!searchValue;

  useEffect(() => {
    handleFetchDataMainCategory();
    handleFetchAllMasterCategories();
  }, []);

  useEffect(() => {
    if (isInit && dataExportMainGroupCsv.length > 0) {
      if (buttonExportMainRef.current) {
        buttonExportMainRef.current.link.click();
      }
    } else {
      setIsInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataExportMainGroupCsv]);

  useEffect(() => {
    if (isInit && dataExportDivisionCsv.length > 0) {
      if (buttonExportDivisionRef.current) {
        buttonExportDivisionRef.current.link.click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataExportDivisionCsv]);

  useEffect(() => {
    if (isInit && dataExportCategoriesCsv.length > 0) {
      if (buttonExportCategoriesRef.current) {
        buttonExportCategoriesRef.current.link.click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataExportCategoriesCsv]);

  useEffect(() => {
    if (isInit && dataExportSubCategories.length > 0) {
      if (buttonExportSubCategoriesRef.current) {
        buttonExportSubCategoriesRef.current.link.click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataExportSubCategories]);

  return {
    loadingButtonDelete,
    handleDelete,
    handleOpenDelete,
    openDeleteForm,
    handleCloseDeleteForm,
    openForm,
    handleCloseForm,
    handleOpenForm,
    loading,
    openMainCategory,
    handleOpenAddCategory,
    handleCloseAddCategory,
    selectedDeleteId,
    selectedMainCategory,
    searchValue,
    handleSearch,
    filterData,
    isSearchNotFound,
    handleOpenEdit,
    handleFetchDataMainCategory,
    selectedMainCategoryId,
    onSetSelectedMain: (newValue: SuppliesMainGroupName) => setSelectedMainCategoryId(newValue),
    loadingUpdateAllCategories,
    buttonExportMainRef,
    dataExportMainGroupCsv,
    handleExportMasterMainCsv,
    dataExportDivisionCsv,
    dataExportCategoriesCsv,
    dataExportSubCategories,
    handleExportMasterDivisionCsv,
    handleExportMasterCategoriesCsv,
    handleExportMasterSubCategoriesCsv,
    buttonExportDivisionRef,
    buttonExportCategoriesRef,
    buttonExportSubCategoriesRef,
    handleUploadMainGroup,
    handleUploadDivision,
    handleUploadCategories,
    handleUploadSubCategories,
    loadingImportMasterMain,
    loadingImportMasterDivision,
    loadingImportMasterCategories,
    loadingImportMasterSubCategories,
  };
};
export default useCategoryController;
